import React from 'react';
import { Card, Form } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { CountrySelectorLabel } from '../../nacre/components/countrySelector';
import { PhoneLabel } from '../../components/phone/phone';
import './organizerProfile.scss';

export default function GeneralInformation({ formOrganisation, onChange, organization, organisationErrors, errorHandler }) {
    const { t } = useTranslation();

    return (
        <Card.FormStep className="organizer-formstep-form" title={t(`ticket.organiser.general_information.title`)} rightComponent id="organiser-form-general_information">
            <>
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.general_information.address')} />
                    <Form.Input
                        errors={errorHandler('address1')}
                        maxLength={80}
                        name="address1"
                        value={formOrganisation.address.address1}
                        onChange={({ target: { value } }) => {
                            onChange('address', { ...formOrganisation.address, address1: value });
                        }}
                    />
                </Form.Field>
                {(formOrganisation?.address?.country === 'CA' || formOrganisation?.address?.country === 'US') && (
                    <Form.Field>
                        <Form.Label label={t('ticket.event.state')} />
                        <Form.Input
                            errors={errorHandler('state')}
                            maxLength={80}
                            name="state"
                            value={formOrganisation.address.state}
                            onChange={({ target: { value } }) => {
                                onChange('address', { ...formOrganisation.address, state: value });
                            }}
                        />
                    </Form.Field>
                )}
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.general_information.zip_code')} />
                    <Form.Input
                        errors={errorHandler('zip_code')}
                        maxLength={80}
                        name="zip_code"
                        value={formOrganisation.address.zip_code}
                        onChange={({ target: { value } }) => {
                            onChange('address', { ...formOrganisation.address, zip_code: value });
                        }}
                    />
                </Form.Field>
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.general_information.city')} />
                    <Form.Input
                        errors={errorHandler('city')}
                        maxLength={80}
                        name="city"
                        value={formOrganisation.address.city}
                        onChange={({ target: { value } }) => {
                            onChange('address', { ...formOrganisation.address, city: value });
                        }}
                    />
                </Form.Field>
                <CountrySelectorLabel
                    errors={errorHandler('country')}
                    label={t('ticket.organiser.general_information.country')}
                    placeholder={t('ticket.event.country_placeholder')}
                    value={formOrganisation.address.country}
                    onChange={value => {
                        onChange('address', { ...formOrganisation.address, country: value });
                    }}
                />
                <PhoneLabel
                    errors={organisationErrors && organisationErrors['phone_number']}
                    label={t('ticket.organiser.general_information.phone')}
                    debounceTimeout={700}
                    value={formOrganisation.phone_number}
                    onChange={value => {
                        onChange('phone_number', value);
                    }}
                />
                <Form.Field>
                    <Form.Label label={t('ticket.organiser.general_information.website')} optionalText={t('ticket.common.labelOptional')} />
                    <Form.Input
                        errors={errorHandler('website')}
                        maxLength={80}
                        name="website"
                        value={formOrganisation.website}
                        onChange={({ target: { value } }) => {
                            onChange('website', value);
                        }}
                    />
                </Form.Field>
                {formOrganisation?.website?.startsWith('http:') && <label className="organizer-form-website-message">{t('ticket.common.validator_website_http')}</label>}
                <Form.FieldErrors errors={[t(organisationErrors['website'])]} />
            </>
        </Card.FormStep>
    );
}
GeneralInformation.propTypes = {
    organization: PropTypes.object.isRequired,
    formOrganisation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    organisationErrors: PropTypes.object.isRequired
};
